import gql from 'graphql-tag'

export const GET_STAFF_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getStaffPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        nameEn
        nameKg
        nameRu
        positionEn
        positionKg
        positionRu
      }
    }
  }
`

export const GET_STAFF_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getStaff (
      data: {
        id: $id
      }
    ) {
      id
      nameEn
      nameKg
      nameRu
      positionEn
      positionKg
      positionRu
      image
    }
  }
`
